/*
 * Shrinks the font size of [data-fit-lines] elements until their text fits the
 * given number of lines. Nothing is ever clipped: if an element reaches the
 * minimum size and still does not fit, it is left to wrap past the line limit.
 *
 * Elements sharing a [data-fit-group] are sized together — the group steps down
 * until every member fits, so they all end up at the same font size.
 */
(function () {
  const MIN_FONT_PX = 8;
  const STEP_PX = 0.25;

  function fitGroup(elements) {
    const maxLines = parseInt(elements[0].dataset.fitLines, 10);
    if (!maxLines) return;

    // Clear any previous fit so the group is measured against the size the
    // stylesheet currently gives it — that changes with the viewport.
    elements.forEach(function (element) {
      element.style.fontSize = '';
    });

    const styles = getComputedStyle(elements[0]);
    const baseSize = parseFloat(styles.fontSize);
    const baseLineHeight = parseFloat(styles.lineHeight);
    if (!baseSize) return;

    // line-height is unitless in the stylesheet, so it tracks the font size.
    const ratio = baseLineHeight ? baseLineHeight / baseSize : 1.5;

    let size = baseSize;
    function allFit() {
      const limit = size * ratio * maxLines + 1;
      return elements.every(function (element) {
        return element.scrollHeight <= limit;
      });
    }

    while (size > MIN_FONT_PX && !allFit()) {
      size -= STEP_PX;
      elements.forEach(function (element) {
        element.style.fontSize = size + 'px';
      });
    }
  }

  function fitAll() {
    const groups = new Map();

    document.querySelectorAll('[data-fit-lines]').forEach(function (element, index) {
      // Ungrouped elements are fitted on their own.
      const key = element.dataset.fitGroup || ' ' + index;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(element);
    });

    groups.forEach(fitGroup);
  }

  let frame = null;
  function scheduleFit() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fitAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitAll);
  } else {
    fitAll();
  }

  // Web fonts change the measurement, as does any reflow of the row.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitAll);
  }
  window.addEventListener('resize', scheduleFit);
  document.addEventListener('shopify:section:load', scheduleFit);
})();
